import React from "react";
import clsx from "clsx";
import "./ripple-effected.styles.scss";

export interface RippleEffectedProps {
	children: React.JSX.Element;
}

export const RippleEffected = (props: RippleEffectedProps) => {
	const { children, ...restProps } = props;
	const child = React.Children.only(children);

	const onClick = React.useCallback(
		(event: React.MouseEvent<HTMLElement>) => {
			const RippleId = "#ripple";
			const eleTarget = event.currentTarget;

			const existedRipple = window.document.getElementById(RippleId);
			if (existedRipple) existedRipple.remove();

			const circle = window.document.createElement("span");
			const diameter = Math.max(eleTarget.clientWidth, eleTarget.clientHeight);
			const radius = diameter / 2;

			circle.style.width = circle.style.height = `${diameter}px`;
			circle.style.left = `${event.nativeEvent.offsetX - radius}px`;
			circle.style.top = `${event.nativeEvent.offsetY - radius}px`;
			circle.id = RippleId;
			circle.classList.add("ripple");

			eleTarget.appendChild(circle);
			circle.addEventListener(
				"animationend",
				function () {
					this.remove();
				},
				{ once: true },
			);

			child.props?.onClick?.(event);
		},
		[child],
	);

	return React.cloneElement(child, {
		...restProps,
		className: clsx(child.props?.className, "--ripple-effected"),
		onClick,
	});
};
